import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TenantUrl, TenantUrlsState } from './types'

const initialState: TenantUrlsState = {
  list: [],
  isLoaded: false,
}

export const slice = createSlice({
  name: 'tenantUrls',
  initialState,
  reducers: {
    showLoader: (state) => {
      state.isLoaded = false
    },
    hideLoader: (state) => {
      state.isLoaded = true
    },
    clearList: () => initialState,
    setList: (state, action: PayloadAction<TenantUrl[]>) => {
      state.list = action.payload
    },
  },
})

export const { showLoader, hideLoader, clearList, setList } = slice.actions

export default slice.reducer
